var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bj-empty"},[_c('el-empty',{staticClass:"empty-page",class:_vm.desc ? '' : 'no-desc',attrs:{"description":_vm.desc,"image":_vm.imgUrl}},[_c('template',{slot:"description"},[_vm._t("description"),_vm._t("default")],2)],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }